import { useEffect, useState } from "react";
import { Download, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

let deferredPrompt = null;
const listeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn(true));
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn(false));
  });
}

export const InstallAppButton = () => {
  const [available, setAvailable] = useState(!!deferredPrompt);
  useEffect(() => {
    listeners.add(setAvailable);
    return () => listeners.delete(setAvailable);
  }, []);
  if (!available) return null;
  const install = async () => {
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    deferredPrompt = null;
    setAvailable(false);
  };
  return (
    <Button variant="outline" onClick={install} data-testid="install-app-btn" className="font-semibold">
      <Download size={16} className="sm:mr-1" /> <span className="hidden sm:inline">Install app</span>
    </Button>
  );
};

export const OfflineBanner = () => {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  return (
    <div data-testid="offline-banner" className="flex items-center gap-2 px-4 sm:px-6 py-2 text-sm text-white" style={{ background: "#B45309" }}>
      <WifiOff size={15} /> You're offline — live data can't load until your connection is back.
    </div>
  );
};
